// This file should only contain action type constants.

// export const SET_FOO = 'SET_FOO';
export const SET_WIDGET_DATA = 'SET_WIDGET_DATA';
export const SET_ACCOUNT_DATA = 'SET_ACCOUNT_DATA';
